import type { User } from '@projektverwaltung/shared';

const COLORS = [
  'bg-rose-500',
  'bg-orange-500',
  'bg-amber-500',
  'bg-emerald-500',
  'bg-teal-500',
  'bg-sky-500',
  'bg-indigo-500',
  'bg-fuchsia-500',
];

function pickColor(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return COLORS[h % COLORS.length] ?? 'bg-slate-500';
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
}

export function Avatar({
  user,
  size = 24,
  title,
}: {
  user: Pick<User, 'name' | 'email' | 'm365_photo_url'> | null | undefined;
  size?: number;
  title?: string;
}) {
  if (!user) {
    return (
      <span
        title={title ?? '–'}
        className="inline-flex items-center justify-center rounded-full bg-slate-200 text-slate-500 text-[10px]"
        style={{ width: size, height: size }}
      >
        ?
      </span>
    );
  }
  const tooltip = title ?? user.name;
  const fontSize = Math.max(10, Math.floor(size * 0.42));
  if (user.m365_photo_url) {
    return (
      <img
        src={user.m365_photo_url}
        alt={user.name}
        title={tooltip}
        className="rounded-full object-cover"
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span
      title={tooltip}
      className={`inline-flex items-center justify-center rounded-full text-white font-medium ${pickColor(user.email)}`}
      style={{ width: size, height: size, fontSize }}
    >
      {initials(user.name)}
    </span>
  );
}
